import { UIThemeProvider, useUITheme } from "@crehana/layouts";
const UITheme_UIThemeProvider = UIThemeProvider;
const UITheme = UITheme_UIThemeProvider;
export default UITheme;
export { UITheme_UIThemeProvider as UIThemeLayout, UITheme_UIThemeProvider as UIThemeProvider, useUITheme };
